import apiClient from '@/services/networking/apiClient';
import {
    GetOrganisationMembersParams,
    GetOrganisationMembersPayload,
    GetOrganisationInvitationResponsePayload,
    GetOrganisationsResponsePayload,
    UpdateMemberRoleParams,
    SendEmailInvitationsParams,
    ActivateInvitation,
    CancelInvitation,
} from '@/types/organisations';

async function getOrganisations(): Promise<GetOrganisationsResponsePayload> {
    const { data } = await apiClient.v2.get<GetOrganisationsResponsePayload>(
        '/organisations',
    );

    return data;
}

async function getMembers(params: GetOrganisationMembersParams) {
    const { data } = await apiClient.v2.get<GetOrganisationMembersPayload>(
        `/organisations/${params.organisationId}`,
    );

    return data;
}

async function getOrganisationInvitation(): Promise<GetOrganisationInvitationResponsePayload> {
    const { data } =
        await apiClient.v2.post<GetOrganisationInvitationResponsePayload>(
            '/invitations/create',
        );
    return data;
}

async function updateMemberRole(params: UpdateMemberRoleParams) {
    const { memberId, organisationId, userRole } = params;
    const { data } = await apiClient.v1.put(
        `/organisations/${organisationId}/users/${memberId}`,
        { user_role: userRole },
    );

    return data;
}

async function sendEmailInvitations(
    params: SendEmailInvitationsParams,
): Promise<void> {
    const { data } = await apiClient.v2.post<void>(
        '/invitations/send_email_invitations',
        {
            emails: params.emails,
        },
    );
    return data;
}

async function activateInvitation(params: ActivateInvitation): Promise<void> {
    await apiClient.v2.post<void>('/invitations/mark_as_active', {
        invitation_id: params.invitationId,
    });
}

async function cancelInvitation(params: CancelInvitation): Promise<void> {
    await apiClient.v2.post<void>('/invitations/cancel', {
        invitation_id: params.invitationId,
    });
}

export const OrganisationsAPI = {
    getOrganisations,
    getMembers,
    getOrganisationInvitation,
    updateMemberRole,
    sendEmailInvitations,
    activateInvitation,
    cancelInvitation,
};
